import withStyles, {
  createStyles,
  WithStyles,
} from 'raydiant-elements/core/withStyles';
import withThemeSelector from 'raydiant-elements/core/withThemeSelector';
import { Theme } from 'raydiant-elements/theme';
import * as React from 'react';
import { colors, maxPageWidth } from '../constants';
import Blurb from './Blurb';

interface CareersBlurbProps extends WithStyles<typeof styles> {}

const CareersBlurb: React.FunctionComponent<CareersBlurbProps> = ({
  classes,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Blurb
          svgIcon={
            <svg className={classes.logo} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M.13 0h6.8V6.837H.13V.001 0zm15.322 6.838h-6.8V0 0h6.8V6.837zm8.523 0h-6.8l-.001-.001V0c3.756 0 6.8 3.061 6.8 6.838zM.13 8.568H6.93V15.406H.13V8.568zm15.32 6.838H8.654h-.001V8.568h6.8V15.406zm-15.32 1.73H6.93v6.838H.13v-6.836-.001zm23.844-8.563c0 3.777-3.045 6.839-6.802 6.839V8.574h6.802zm-8.523 8.564v6.837c-3.755 0-6.8-3.06-6.8-6.837h6.8zm1.723 0h6.799V23.976h-6.8v-6.837-.002z"
              />
            </svg>
          }
          borderColor={colors.navy}
          bodyColor={colors.skyBlue}
        >
          At Raydiant, we have a set of beliefs that help guide how we work,
          play, and <br />
          solve big problems together. If these align with what you value, there
          just <br />
          might be a role with your name on it.
          <br />
          <br />
          We are passionate about:
          <ul>
            <li>Put the customer at the center of everything we do.</li>
            <li>We take extreme ownership of our results.</li>
            <li>
              Across the entire company, everyone is taking action that drives
              results every single day.
            </li>
            <li>
              Push for high standards; we want to continue to be a brand that
              customers love.
            </li>
            <li>Stay scrappy & frugal.</li>
            <li>
              Learning keeps us in motion – and we promote it across the
              company.{' '}
            </li>
          </ul>
          By practicing these principles day after day, we will succeed at
          reaching our <br />
          vision and be a place where every member of our (work) family can do
          what <br />
          they love every single day.
        </Blurb>
      </div>
    </div>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.palette.background.default,
      paddingTop: theme.spacing.unit * 10,
      paddingBottom: theme.spacing.unit * 10,

      [theme.breakpoints.down('sm')]: {
        paddingBottom: theme.spacing.unit * 5,
      },
    },
    inner: {
      width: '100%',
      maxWidth: maxPageWidth,
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
    },
    logo: {
      width: 24,
      height: 24,
      color: theme.palette.text.heading,
      position: 'absolute',
      top: 0,
      left: -theme.spacing.unit * 2,

      [theme.breakpoints.down('xs')]: {
        top: -theme.spacing.unit * 5,
        left: 0,
      },
    },
  });

export default withThemeSelector(withStyles(styles)(CareersBlurb), 'light');
